import type { ElementGroupRowIndexProps } from "./types";

export const ElementGroupRowIndex = ({ index }: ElementGroupRowIndexProps) => {
  return (
    <span className="min-w-4 text-right text-gray-500 flex-shrink-0">
      {index + 1}.
    </span>
  );
};
